import { X } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import type { FilterValue, FilterField } from "../types";

interface FilterRowProps {
  filter: FilterValue;
  fields: FilterField[];
  onUpdate: (filter: FilterValue) => void;
  onRemove: () => void;
}

export function FilterRow({
  filter,
  fields,
  onUpdate,
  onRemove,
}: FilterRowProps) {
  const selectedField = fields.find((f) => f.id === filter.field);

  return (
    <div className="aero:flex aero:items-center aero:gap-2">
      <Select
        value={filter.field}
        onValueChange={(value) =>
          onUpdate({ ...filter, field: value, value: "" })
        }
      >
        <SelectTrigger className="aero:h-10 aero:flex-1 aero:min-w-0 aero:rounded aero:border-neutral-300">
          <SelectValue placeholder="Select Field" />
        </SelectTrigger>
        <SelectContent>
          {fields.map((field) => (
            <SelectItem key={field.id} value={field.id}>
              {field.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select
        value={filter.operator}
        onValueChange={(value) => onUpdate({ ...filter, operator: value })}
      >
        <SelectTrigger className="aero:h-10 aero:flex-1 aero:min-w-0 aero:rounded aero:border-neutral-300">
          <SelectValue placeholder="Contains" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="contains">Contains</SelectItem>
          <SelectItem value="equals">Equals</SelectItem>
          <SelectItem value="startsWith">Starts With</SelectItem>
          <SelectItem value="endsWith">Ends With</SelectItem>
        </SelectContent>
      </Select>
      {selectedField?.options ? (
        <Select
          value={filter.value}
          onValueChange={(value) => onUpdate({ ...filter, value })}
        >
          <SelectTrigger className="aero:h-10 aero:flex-1 aero:min-w-0 aero:rounded aero:border-neutral-300">
            <SelectValue placeholder="Select value" />
          </SelectTrigger>
          <SelectContent>
            {selectedField.options.map((opt) => (
              <SelectItem key={opt.value} value={opt.value}>
                {opt.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : (
        <Input
          value={filter.value}
          onChange={(e) => onUpdate({ ...filter, value: e.target.value })}
          placeholder="Enter Text"
          className="aero:w-full aero:h-10 aero:rounded aero:border aero:py-3 aero:pr-4 aero:pl-10"
        />
      )}
      <Button
        type="button"
        intent="destructive"
        design="outline"
        size="iconMd"
        onClick={onRemove}
      >
        <X className="aero:h-5 aero:w-5" />
      </Button>
    </div>
  );
}
